<template>
  <div
    class="flex flex-col w-full items-center px-4"
    :class="{
      'bg-gradient-to-tr from-utility-brand-900_alt to-utility-brand-600_alt':
        !user.avatar_url,
      'rounded-t-xl gap-4 py-3': !maxSmall,
      'rounded-xl gap-1 py-6': maxSmall,
    }"
    :style="
      user.avatar_url
        ? `background: linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), url('${user.avatar_url}') lightgray 50% / cover no-repeat;`
        : ''
    "
  >
    <div v-if="!maxSmall" class="flex self-start">
      <Tooltip
        :title="$t('components.tooltips.edit')"
        side="bottom"
        class="w-fit"
        ignoreNonKeyboardFocus
        disableHoverableContent
      >
        <Button
          icon
          variant="secondary"
          type="filled"
          size="sm"
          class="border-0 opacity-70"
          @click="$emit('profileEdit')"
        >
          <Icon name="edit-pen" />
        </Button>
      </Tooltip>
    </div>
    <Avatar
      :src="user.avatar_url"
      :initials="user.avatar_initials"
      class="text-4xl m-auto shadow-lg outline outline-4 outline-offset-0 outline-alpha-white-30"
      :class="{
        'w-24 h-24 rounded-5xl': !maxSmall,
        'w-16 h-16 rounded-3xl': maxSmall,
      }"
      size="3xl"
    />
    <div class="flex flex-col max-w-full">
      <div
        class="text-2xl font-medium text-primary_on-brand m-auto truncate max-w-full"
      >
        {{ user.firstname }} {{ user.lastname }}
      </div>
      <div
        class="font-medium text-alpha-white-50 m-auto"
        :class="{
          'text-style-sm -mt-1': maxSmall,
          'text-style-xs pb-4': !maxSmall,
        }"
      >
        {{ user.email }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { Avatar } from "@/SharedComponents/Avatars";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["profileEdit"]);

defineProps({
  user: {
    type: Object,
    required: true,
    validator: (value) => {
      return value.id && value.firstname;
    },
  },
});
</script>
